  <template>
  <div class="exhibitionList">
    <el-col class="infoPub" style="width: 990px">
      <!-- 列表组件 -->
      <div class="content">
        <router-view></router-view>
      </div>
    </el-col>
  </div>
</template>
<script>
import { language } from "../../../language/get";
import { ExhIndexType } from "../../../common/constant/exhibition";
import Cookie from "../../../common/cookie";
import searchBar from "../components/searchbar/searchbar";
import bbsList from "../components/bbslist/bbslist";
import tablePage from "../components/tablepage/tablepage";
import { isEmpty, isInternet } from "../../../common/validate";
import { roomUrl, windowsGoTo } from "../../../common/url";
import dialogPub from "../components/dialogpub/dialogpub";
const pubLanguage = language();
import downloadDialog from "../../../components/DownloadDialog/index";
import { selectList } from "../../../api/exhibition";
import { mapGetters } from "vuex";
import { getLiveUrl } from "../../../api/forum";
import axios from "axios";

const initialization = {
  broadcast_id: "",
  broadcast_class_id: "",
  broadcast_name: "",
  broadcast_name_en: "",
  location: "",
  location_en: "",
  broadcast_name1: "",
  user_post: "",
  user_post_en: "",
  truename: "",
  truename_en: "",
  broadcast_class_name: "",
  tel: "",
  broadcast_introduce: "",
  broadcast_introduce_en: "",
  broadcast_logo: null,
  broadcast_applent_logo: null
};
export default {
  components: {
    searchBar,
    bbsList,
    tablePage,
    downloadDialog,
    dialogPub
  },
  computed: {
    ...mapGetters(["token", "userInfo"])
  },
  data() {
    return {
      loading: "true",
      downloadShow: false,
      ExhIndexType,
      imgList: [],
      language: language(),
      lan: Cookie.get("lang"),
      //page
      pageTotal: 0,
      pageSize: 6,
      currentPage: 1,
      layout: "prev, pager, next, jumper",
      exhibitionList: [],
    };
  },
  created() {
    //this.getList();
  },
  mounted() {
    
  },
  methods: {
    goGuestList(e){
      this.$router.push({
        path:'/exhibitionList/guestList'
      })
    },
    
    //分页
    pageChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getList() {
      let that = this;
      let data = {
        token: this.$store.state.user.token,
        currentPage: this.currentPage,
        numberPage: this.pageSize,
      };
      selectList(data).then(res => {
        if (res.type == "1") {
          res.data.forEach(item => {
            if (this.lan == "en") {
              item.exh_begtime = `${item.exh_begtime_en}`;
              item.exh_endtime = `${item.exh_endtime_en}`;
            }
          });
          this.exhibitionList = res.data;
          this.pageTotal = res.datacount;
          console.log(this.pageTotal)
        } else {
          if (this.lan == "ch") {
            return this.$message.error({ message: res.text, offset: 120 });
          }
          return this.$message.error({ message: res.text_en, offset: 120 });
        }
      });
    },

  }
};
</script>
<style scoped>
  .content{
      height: 550px;
      /* background: #ffffff; */
  }
  .content-title{
    height: 20px;
    line-height: 20px;
    border-bottom: 1px solid #cccccc;
    padding: 10px 20px;
    font-size: 14px;
  }
  .content-exhibitionList{
    padding: 20px;
    border-bottom: 1px solid #cccccc;
    display: flex;
  }
  .content-exhname{
    flex: 1;
    font-size: 16px;
    line-height: 29px;
  }
  .content-exhname-btn{
    padding: 5px 10px;
    background: #107ce6;
    color: #fff;
    border-radius: 8px;
    cursor: pointer;
  }

</style>
  <style>
.bbsdialog .el-dialog {
  max-height: none;
}
.el-upload-list--picture-card .el-upload-list__item-status-label i {
  margin-top: 6px;
}
.bbsdialog .el-dialog__header {
  position: relative;
}
.bbsdialog .el-dialog__headerbtn {
  top: 4px;
}
.total-data {
  background: #ffffff;
  font-size: 18px;
  color: #434343;
  padding: 14px 10px;
}
.total-data > span {
  margin-right: 40px;
}
.dislogCon{
  text-align: center;
}
.img-formBtn{
  margin: 0 auto;
  text-align: center;
}
.img-down-formBtn{
    background: #ff9e00;
    width: 100px;
    height: 40px;
    color: #ffffff;
    border: none;
    font-size: 18px;
}
.img-camcale-formBtn{
    background: #cccccc;
    width: 100px;
    height: 40px;
    color: #ffffff;
    border: none;
    font-size: 18px;
}

</style>